import { render, staticRenderFns } from "./BrbDateTimeDisplay.vue?vue&type=template&id=57ced7da&"
import script from "./BrbDateTimeDisplay.vue?vue&type=script&lang=js&"
export * from "./BrbDateTimeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/admin-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ced7da')) {
      api.createRecord('57ced7da', component.options)
    } else {
      api.reload('57ced7da', component.options)
    }
    module.hot.accept("./BrbDateTimeDisplay.vue?vue&type=template&id=57ced7da&", function () {
      api.rerender('57ced7da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/brb-components/BrbDateTimeDisplay.vue"
export default component.exports